var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnselectDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5002,
    cy: 20.7142,
    rx: 3.25,
    ry: 3.28573,
    stroke: "#011621",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.125,
    cy: 20.7142,
    rx: 3.25,
    ry: 3.28573,
    stroke: "#011621",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 12.5001H12.375V1M12.375 1V4.28573H1V18.7144C1 19.819 1.89543 20.7144 3 20.7144H5.875M12.375 1H18.875L26.6289 7.27129C26.8636 7.46115 27 7.7469 27 8.04881V10.8572M22.125 4.28573H20.5V10.8572H27M27 10.8572V18.7144C27 19.819 26.1046 20.7144 25 20.7144H23.75M17.25 20.7144H12.375",
    stroke: "#011621",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectDriver);
export default __webpack_public_path__ + "static/media/unselect_driver.39b2e0fd7a4468253a4fab8c90243040.svg";
export { ForwardRef as ReactComponent };